import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/authentication';
import { ToastrService } from 'ngx-toastr';
import { ServiceProvider } from '../../../core/service/service.provider';

@Component({
  selector: 'app-login-form',
  templateUrl: './loginform.component.html'
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    public dataService: ServiceProvider,
  ) {
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      // isRemember: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = '/productselection';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  loginSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    
    this.authenticationService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data.auth_token) {
            localStorage.setItem('accessToken', data.auth_token)
            localStorage.setItem('roles', JSON.stringify(data.roles))
            localStorage.setItem('refresh_interval', JSON.stringify(data.refresh_expiry))
            if(data.roles.length == 1){
              localStorage.setItem('userRole', JSON.stringify(data.roles[0]))
              this.toastr.success('Logged in successfully', 'Success');
              this.router.navigate(['/dashboard']);
            }else if(data.roles.length == 0){
              this.toastr.error('User role details not found!', 'Failed');
            }else if(data.roles.length > 1){
              this.router.navigate(['/role-select']);
            }
            
          } else {
            this.toastr.error('Unautherised login attempt!', 'Failed');
          }
        },
        err => {
          if(typeof(err.error) == 'object'){
            for(let er in err.error){
              this.toastr.error(er + ' - '+ err.error[er].join(', ') ,'Failed');
            }
          }else if(typeof(err.error) == 'string'){
            this.toastr.error(err.error,'Failed');
          }
          this.loading = false;
        });
  }

  formErrValue(er){
    if(Array.isArray(er)){
      return er.join(', ')
    }else{
      return er
    }
  }

}
